import { Form } from 'antd';
import { useGo } from '@refinedev/core';
import useHasChanges from "./useHasChanges";
import useRequiredFieldsFilled from "./useRequiredFieldsFilled";


export default function ButtonSectionController({
  initialValues,
  children,
}) {
  const go = useGo();
  const values = {
    categories: Form.useWatch(['categories']),
  };
  const hasChanges = useHasChanges({ initialValues, values });
  const requiredFieldsFilled = useRequiredFieldsFilled(values);
  return children({
    props: {
      save: {
        disabled: !hasChanges || !requiredFieldsFilled,
      },
      popConfirm: {
        onConfirm: () => go({ to: '..' }),
      },
      close: {
        onClick: !hasChanges ? () => go({ to: '..' }) : null,
      },
    },
    hasChanges,
  });
}